<template>
  <div id="license">
    <v-layout align-center justify-center>
      <v-flex xs12 sm10 md8>
      <v-card outline raised>
      <v-card-title>License Agreement</v-card-title>
      <v-card-text pa-2 style="text-justify: 'inter-character'">
        <p>Effective as of March 23, 2020</p>
        <p>Welcome to the v-Feed Terms and Conditions of Use ("Terms").</p>
        <p>
          <b>1 Introduction</b>
        </p>
        <p>Thanks for choosing V-Feed ("V-Feed", "we", "us", "our"). V-Feed provides livestock feed management system.</p>
        <p>
          Your agreement with us includes these Terms including terms regarding
          future changes to the Agreements, automatic renewals, and limitations of liability,
          privacy. If you wish to review the terms of the Agreements, the current effective version of the
          Agreements can be found on V-Feed's website. You acknowledge that you have read and understood the
          Agreements, accept these Agreements, and agree to be bound by them. If you don't agree with
          (or cannot comply with) the Agreements, then you may not use V-FeedWs Services.
        </p>

        <p>
          <b>2 Future Changes to the Agreements</b>
        </p>
        <p></p>
        <p>
          Occasionally we may make changes to the Agreements. When we
          make material changes to the Agreements, we'll provide you with notice by
          sending you an email. If you do not wish to continue using the Service after
          these changes, you may terminate your account by contacting us. If you
          received a Trial or a Paid Subscription through a third party, you must cancel
          the applicable Paid Subscription through such third party.
        </p>
        <p>
          <b>3 Trials</b>
        </p>
        <p>
          From time to time, we or others on our behalf may offer trials
          of Paid Subscriptions for a specified period without payment or at a reduced
          rate (a "Trial"). V-Feed may determine your eligibility for a Trial, and
          withdraw or modify a Trial at any time without prior notice and with no
          liability, to the extent permitted under applicable law.
        </p>

        <p>
          <b>4 Payments and Cancellations</b>
        </p>
        <p>
          You may purchase a Paid Subscription directly from V-Feed or
          through a third party by paying a subscription fee in advance on a monthly
          basis or some other recurring interval disclosed to you prior to your purchase.
        </p>
        <p>
          V-Feed may change the price for the Paid Subscriptions,
          including recurring subscription fees, from time to time and will communicate
          any price changes to you in advance and, how to accept those changes. Price
          changes will take effect at the start of the next subscription period following
          the date of the price change. You accept the new price by continuing to use the
          V-Feed Service after the price change takes effect. If you do not agree with a
          price change, you have the right to reject the change by unsubscribing from the
          Paid Subscription prior to the price change going into effect.
        </p>
        <p>
          Your payment to V-Feed or the third party through which you
          purchased the Paid Subscription will automatically renew at the end of the applicable
          subscription period, unless you cancel your Paid Subscription before the end of
          the then-current subscription period.
        </p>

        <p>
          <b>5 Using our service</b>
        </p>

        <p>
          The V-Feed Service are the property of V-Feed or V-Feed's
          licensors. We grant you limited, non-exclusive, revocable permission to make
          use of the V-Feed Service. This Access shall remain in effect until and unless
          terminated by you or V-Feed. You promise and agree that you are using the V-Feed
          Service and Content for your own use and that you will not redistribute or
          transfer the accesses to V-Feed's Service.
        </p>
        <p>
          The V-Feed software applications are not sold or transferred
          to you, and V-Feed and its licensors retain ownership of all copies of the V-Feed
          software applications even after installation on your personal computers,
          mobile handsets, tablets, and/or other devices ("Devices").
        </p>
        <p>
          All V-Feed trademarks, service marks, trade names, logos,
          domain names, and any other features of the V-Feed brand are the sole property
          of V-Feed or its licensors. The Agreements do not grant you any rights to use
          any V-Feed Brand Features whether for commercial or non-commercial use.
        </p>
        <p>
          Third party software (for example, open source software
          libraries) included in the V-Feed Service are made available to you under the
          relevant third party software library's license terms.
        </p>

        <p>
          <b>6 User-Generated Content</b>
        </p>

        <p>
          V-Feed users may post, upload, content to the Service (which
          may include, for example, pictures, text, messages, information, and/or other
          types of content) ("User Content"). For the avoidance of doubt, "User Content"
          includes any such content posted to the V-Feed Support channels as well as any
          other part of the V-Feed Service. You promise that, with respect to any User
          Content you post on V-Feed you own or have the right to post such User Content.
        </p>
        <p>
          V-Feed may, but has no obligation to, monitor or review User
          Content for the purpose of service improvement, training and customer support.
        </p>

        <p>
          <b>7 User guidelines</b>
        </p>

        <p>
          V-Feed respects intellectual property rights and expects you
          to do the same. The following is not permitted for any reason whatsoever:
        </p>
        <ul>
          <li>reverse-engineering, decompiling, disassembling, modifying, or creating derivative works of the V-Feed Service, Content or any part thereof except to the extent permitted by applicable law</li>
          <li>circumventing any technology used by V-Feed, its licensors, or any third party to protect the Content or the Service</li>
          <li>selling, renting, sublicensing or leasing of any part of the V-Feed Service</li>
          <li>providing your password to any other person or using any other person’s username and password</li>
          <li>“crawling” the V-Feed Service or otherwise using any automated means (including bots, scrapers, and spiders) to view, access or collect information from V-Feed or the V-Feed Service</li>
          <li>includes your password or purposely includes any other user’s password or purposely includes personal data of third parties or is intended to solicit such personal data</li>
          <li>interferes with or in any way disrupts the V-Feed Service, tampers with, breaches, or attempts to probe, scan, or test for vulnerabilities in the Service or V-Feed’s computer systems, network, usage rules, or any of V-Feed’s security components, authentication measures or any other protection measures applicable to the Service, the Content or any part thereof</li>
          <li>conflicts with the Agreements, as determined by V-Feed.</li>
        </ul>

        <p>
          Your password protects your user account, and you are solely
          responsible for keeping your password confidential and secure. You understand
          that you are responsible for all use (including any unauthorized use) of your
          username and password on the Service. If your username or password is lost or
          stolen, or if you believe there has been unauthorized access to your account by
          a third party, you must notify us immediately and change your password as soon
          as possible.
        </p>

        <p>
          <b>9 Service limitations and modifications</b>
        </p>

        <p>
          V-Feed will make reasonable efforts to keep the V-Feed
          Service operational. However, certain technical difficulties, maintenance or
          testing, or updates required to reflect changes in relevant laws and regulatory
          requirements, may, from time to time, result in temporary interruptions. V-Feed
          reserves the right, periodically and at any time, to modify or discontinue,
          temporarily or permanently, functions and features of the V-Feed Service, with
          advance notice where possible, all without liability to you, except where
          prohibited by law, for any interruption, modification, or discontinuation of
          the V-Feed Service or any function or feature thereof. You understand, agree,
          and accept that V-Feed will make reasonable efforts, although it has no
          obligation to maintain, support, upgrade, or update the Service, or to provide
          all or any specific content through the Service. This section will be enforced
          to the extent permissible by applicable law.
        </p>

        <p>
          <b>10 Organization Accounts</b>
        </p>

        <p>
          If you establish a V-Feed account on behalf of a company, organization, or entity
          the terms "you" and "your", as used throughout the Agreements, apply to both you and the organization.
        </p>

        <p>
          <b>11 Customer support</b>
        </p>

        <p>
          For customer support with account-related and
          payment-related questions ("Customer Support Inquiries"), please submit a
          ticket to our Customer Service department using the Customer Service contact
          form on our website. We will use reasonable actions to respond to all
          Customer Support Inquiries within a reasonable time frame, but we make no
          promises that any Customer Support Inquiries will be responded to within any
          particular time frame and/or that we will be able to answer any such queries.
        </p>

        <p>
          <b>12 Term and termination</b>
        </p>

        <p>
          The Agreements will continue to apply to you until
          terminated by either you or V-Feed. V-Feed may terminate the Agreements or
          suspend your access to the V-Feed Service at any time, including in the event
          of your actual or suspected unauthorized use of the V-Feed Service, or
          non-compliance with the Agreements. If you or V-Feed terminate the Agreements,
          or if V-Feed suspends your access to the V-Feed Service, you agree that V-Feed
          shall have no liability or responsibility to you, and V-Feed will not refund
          any amounts that you have already paid, to the fullest extent permitted under
          applicable law. You may terminate the Agreements at any time. To learn how to
          terminate your V-Feed account, please contact us through the Customer
          Service contact form on our website. This section will be enforced to
          the extent permissible by applicable law.
        </p>

        <p>
          <b>13 Warranty disclaimer</b>
        </p>

        <p>
          YOU UNDERSTAND AND AGREE THAT THE V-FEED SERVICE IS PROVIDED
          "AS IS" AND "AS AVAILABLE", WITHOUT EXPRESS OR IMPLIED WARRANTY OR CONDITION OF
          ANY KIND. V-FEED MAKE NO REPRESENTATIONS AND DISCLAIM ANY WARRANTIES OR
          CONDITIONS OF SATISFACTORY QUALITY, MERCHANTABILITY, FITNESS FOR A PARTICULAR
          PURPOSE, OR NON-INFRINGEMENT. NEITHER V-FEED NOR ANY OWNER OF CONTENT WARRANTS
          THAT THE V-FEED SERVICE IS FREE OF MALWARE OR OTHER HARMFUL COMPONENTS. IN
          ADDITION, V-FEED MAKES NO REPRESENTATION NOR DOES IT WARRANT, ENDORSE,
          GUARANTEE, OR ASSUME RESPONSIBILITY FOR ANY THIRD PARTY APPLICATIONS (OR THE
          CONTENT THEREOF), USER CONTENT, DEVICES OR ANY OTHER PRODUCT OR SERVICE
          ADVERTISED, PROMOTED OR OFFERED BY A THIRD PARTY ON OR THROUGH THE V-FEED
          SERVICE OR ANY HYPERLINKED WEBSITE, OR FEATURED IN ANY BANNER OR OTHER ADVERTISING
          AND V-FEED IS NOT RESPONSIBLE OR LIABLE FOR ANY TRANSACTION BETWEEN YOU AND
          THIRD PARTY PROVIDERS OF THE FOREGOING. NO ADVICE OR INFORMATION WHETHER ORAL
          OR IN WRITING OBTAINED BY YOU FROM V-FEED SHALL CREATE ANY WARRANTY ON BEHALF
          OF V-FEED. THIS SECTION APPLIES TO THE FULLEST EXTENT PERMITTED BY APPLICABLE
          LAW.
        </p>
        <p>THIS SECTION DOES NOT AFFECT YOUR STATUTORY RIGHTS AS A CONSUMER.</p>

        <p>
          <b>14 Limitation and time for filing</b>
        </p>

        <p>
          YOU AGREE THAT
          <span class="3DGramE">YOUR</span> SOLE AND
          EXCLUSIVE REMEDY FOR ANY PROBLEMS OR DISSATISFACTION WITH THE V-FEED SERVICE IS
          TO UNINSTALL ANY V-FEED SOFTWARE AND TO STOP USING THE V-FEED SERVICE. YOU
          AGREE THAT V-FEED HAS NO OBLIGATION OR LIABILITY ARISING FROM OR RELATED TO
          THIRD PARTY APPLICATIONS OR THE CONTENT THEREOF MADE AVAILABLE THROUGH OR IN
          CONNECTION WITH THE V-FEED SERVICE, AND WHILE YOUR RELATIONSHIP WITH SUCH THIRD
          PARTY APPLICATIONS MAY BE GOVERNED BY SEPARATE AGREEMENTS WITH SUCH THIRD
          PARTIES, YOUR SOLE AND EXCLUSIVE REMEDY, AS WITH RESPECT TO V-FEED, FOR ANY
          PROBLEMS OR DISSATISFACTION WITH THIRD PARTY APPLICATIONS OR THE CONTENT
          THEREOF, IS TO UNINSTALL AND/OR STOP USING ANY SUCH THIRD PARTY APPLICATIONS.
        </p>
        <p>
          IN NO EVENT WILL V-FEED, ITS OFFICERS, SHAREHOLDERS,
          EMPLOYEES, AGENTS, DIRECTORS, SUBSIDIARIES, AFFILIATES, SUCCESSORS, ASSIGNS,
          SUPPLIERS, OR LICENSORS BE LIABLE FOR (1) ANY INDIRECT, SPECIAL, INCIDENTAL,
          PUNITIVE, EXEMPLARY, OR CONSEQUENTIAL DAMAGES; (2) ANY LOSS OF USE, DATA,
          BUSINESS, OR PROFITS (WHETHER DIRECT OR INDIRECT), IN ALL CASES ARISING OUT OF
          THE USE OF OR INABILITY TO USE THE V-FEED SERVICE, DEVICES THIRD PARTY
          APPLICATIONS, OR THIRD PARTY APPLICATION CONTENT, REGARDLESS OF LEGAL THEORY,
          WITHOUT REGARD TO WHETHER V-FEED HAS BEEN WARNED OF THE POSSIBILITY OF THOSE
          DAMAGES, AND EVEN IF A REMEDY FAILS OF ITS ESSENTIAL PURPOSE; OR (3) AGGREGATE
          LIABILITY FOR ALL CLAIMS RELATING TO THE V-FEED SERVICE, THIRD PARTY
          APPLICATIONS, OR THIRD PARTY APPLICATION CONTENT MORE THAN THE AMOUNTS PAID BY
          YOU TO V-FEED DURING THE PRIOR TWELVE MONTHS IN QUESTION.
        </p>
        <p>
          Nothing in the Agreements removes or limits V-Feed�s
          liability for fraud, fraudulent misrepresentation, death or personal injury
          caused by its negligence, and, if required by applicable law, gross negligence.
        </p>
        <p>
          YOU AGREE THAT ANY CLAIM AGAINST V-FEED MUST BE COMMENCED WITHIN
          ONE (1) YEAR AFTER THE DATE THE PARTY ASSERTING THE CLAIM FIRST KNOWS OR
          REASONABLY SHOULD KNOW OF THE ACT, OMISSION, OR DEFAULT GIVING RISE TO THE
          CLAIM; AND THERE SHALL BE NO RIGHT TO ANY REMEDY FOR ANY CLAIM NOT ASSERTED
          WITHIN THAT TIME PERIOD.
        </p>
        <p>THIS SECTION APPLIES TO THE FULLEST EXTENT PERMITTED BY APPLICABLE LAW.</p>

        <p>
          <b>15 Entire Agreement</b>
        </p>

        <p>
          Other than as stated in this section or as explicitly agreed
          upon in writing between you and V-Feed, the Agreements constitute all the terms
          and conditions agreed upon between you and V-Feed and supersede any prior
          agreements in relation to the subject matter of these Agreements, whether
          written or oral.
        </p>
        <p>
          Please note, however, that certain aspects of your use of
          the V-Feed Service may be governed by additional agreements. That could
          include, for example, free or discounted Trials, or together with other
          services. When you are presented with an offer for such aspects of your use,
          you will be presented with any related additional agreement, and you may have
          an opportunity to agree to additional terms. To the extent that there is any
          irreconcilable conflict between any additional terms and these Terms, the
          additional terms shall prevail.
        </p>

        <p>
          <b>22 Assignment</b>
        </p>

        <p>
          V-Feed may assign the Agreements, and any of its rights
          under the Agreements, in whole or in part, and V-Feed may delegate any of its
          obligations under the Agreements. You may not assign the Agreements, in whole
          or in part, nor transfer or sub-license your rights under the Agreements, to
          any third party.
        </p>

        <p>
          <b>23 Indemnification</b>
        </p>

        <p>
          You agree to indemnify and hold V-Feed harmless from and
          against all damages, losses, and expenses of any kind (including reasonable
          attorney fees and costs) arising out of or related to: (1) your breach of the
          Agreements or any one of them; (2) any User Content you post or otherwise
          contribute; (3) any activity in which you engage on or through the V-Feed
          Service; and (4) your violation of any law or the rights of a third party.
        </p>

        <p>
          <b>25 Contact us</b>
        </p>

        <p>
          If you have any questions concerning the V-Feed Service or the Agreements,
          please contact V-Feed Customer Service contact form on our website.
        </p>

        <p style="font-family: 'Pacifico', 'Times New Roman'">V-Feed</p>
        </v-card-text>
        <v-card-actions pa-3>
          <!-- <router-link to="{name: 'login', component: 'Login', props: true}">Back</router-link> -->
          <v-btn text small ma-3 pa-3 @click="goBack">Back</v-btn>
          <v-btn text small ma-3 pa-3 @click="toTop">Top</v-btn>

          <!-- @click.native="scrollTop" -->
        </v-card-actions>
      </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
  export default {
    name: 'login',
    methods: {
      toTop() {
        this.$vuetify.goTo(0);
      },
      goBack() {
        this.$router.replace({name: 'signup'});
      }

    }
  }
</script>
